/* eslint-disable react/no-array-index-key */
import React, { useCallback } from "react";
import { useDispatch } from "react-redux";

import { setNewSourceStore, setNewTargetStore, setNotification } from "../../../store/wizardCreate/wizardCreateSlice";
import { useCheckTypeConnectMutation } from "../../../store/wizardCreate/wizardCreateService";

import { CustomLink } from "./styles";

const SetNewStore = ({ error, variables, setMessage }) => {
  const dispatch = useDispatch();
  const placeholder = `{{${variables?.link?.type}}}`;
  const messageParts = error?.split(placeholder) || [];

  const [checkTypeConnect] = useCheckTypeConnectMutation();

  const handleScroll = useCallback(() => {
    document
      .getElementsByClassName("wizard-select-platform")[0]
      ?.scrollIntoView({ behavior: "smooth" });
  }, []);

  const handleCheckTypeConnect = async (value, cartType) => {
    try {
      const payload = { type: cartType };
      if (cartType === "source") {
        payload.source_cart_id = value;
      } else {
        payload.target_cart_id = value;
      }
      await checkTypeConnect(payload).unwrap();
    } catch (error) {
      dispatch(setNotification(error));
    }
  };

  const changeStore = () => {
    if (variables["{{storeType}}"] === "source") {
      dispatch(setNewSourceStore(variables["{{cartId}}"]));
    } else {
      dispatch(setNewTargetStore(variables["{{cartId}}"]));
    }

    handleCheckTypeConnect(variables["{{cartId}}"], variables["{{storeType}}"]);

    if (setMessage) {
      setMessage("");
    }

    handleScroll();
    dispatch(setNotification(""));
  };

  return (
    <>
      {messageParts.map((part, index) => (
        <span key={index}>
          <span dangerouslySetInnerHTML={{ __html: part }} />
          {index < messageParts.length - 1 && (
            <CustomLink onClick={changeStore}>
              {variables["{{cartId}}"]}
            </CustomLink>
          )}
        </span>
      ))}
    </>
  );
};

export default SetNewStore;
